import Vue from 'vue'
import App from '@/App'
import store from '@/store'
import router from '@/router'
import { vueLoader } from './loader'
/* eslint-disable no-new */

const isMobile = true

vueLoader({
  isMobile,
  el: '#app',
  store,
  router,
  components: { 
    App 
  },
  template: '<App/>'
})






// WEBPACK FOOTER //
// ./src/main.js